<template>
    <div component="LocationSelects">
        <label v-if="getIsSmallScreen">State</label>
        <v-select
            class="input select"
            :value="state"
            item-text="name"
            :items="getLocationsOptions('state')"
            :label="!getIsSmallScreen ? 'State' : ''"
            @change="onLocationChange($event, 'state')"
            return-object
            hide-details
            clearable
        />
        <label v-if="getIsSmallScreen">County</label>
        <v-select
            class="input select"
            :value="county"
            item-text="name"
            no-data-text="Select state"
            :items="getLocationsOptions('county', 'state')"
            :label="!getIsSmallScreen ? 'County' : ''"
            @change="onLocationChange($event, 'county')"
            return-object
            hide-details
            clearable
        />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { EnumsApi } from '@/api';
export default {
    name: 'LocationSelects',

    props: {
        value: {
            type: Number | Object,
            required: true,
        },
        returnObject: {
            type: Boolean,
        },
    },

    data: () => ({
        records: [],
        state: null,
        county: null,
    }),

    created() {
        this.load();
    },

    methods: {
        async load() {
            const { data } = await EnumsApi.loadLocations({
                include: ['type', 'parent', 'parent.type'],
                sort: ['type_id.asc', 'parent_id.asc', 'name.asc'],
            });
            this.records = data.records;
            this.setValues();
        },

        getLocation(type) {
            return this.location?.type.slug == type
                ? this.location
                : this.location?.parent?.type.slug == type
                ? this.location?.parent
                : null;
        },

        setValues() {
            this.state = this.getLocation('state');
            this.county = this.getLocation('county');
        },

        onLocationChange(location, type) {
            let value;
            switch (type) {
                case 'state':
                    value = location || null;
                    this.county = null;
                    break;
                case 'county':
                    value = location || this.state;
                    break;
            }
            value = this.returnObject ? value : value?.id || null;
            this.$emit('input', value);
            this.$emit('change', value);
            this.$emit('update', value);
        },
    },

    computed: {
        ...mapGetters(['getIsSmallScreen']),

        getLocationsOptions() {
            return (type, parentType) =>
                this.records.filter(
                    (item) =>
                        item.type.slug == type && (!parentType || item.parent?.id == this.getLocation(parentType)?.id)
                );
        },

        location() {
            const id = this.value?.id ?? this.value;
            return this.records.find((r) => r.id == id);
        },
    },

    watch: {
        value() {
            this.setValues();
        },
    },
};
</script>
